<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'周目标汇总'}]" />-->
      <Breadtabsheader/>
        <div class="h-content">
            <!-- 搜素条件 -->
          <div class="h-piece">
            <div class="h-formBox">
              <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                <div class="h-thirdColumn w-newColumn">
                  <el-form-item label="姓名">
                    <el-input v-model="q.userName" placeholder="请输入创客名称"></el-input>
                  </el-form-item>

                  <el-form-item label="区域" prop="searchQuyu">
                    <brselect clearable category="show_area" :v="q.quyuCode"
                              v-model="q.quyuCode"></brselect>
                  </el-form-item>

                <el-form-item label="年度">
                  <el-select filterable v-model="q.year" clearable placeholder="请选择"
                             @change="getqWeeksBySelectYear">
                    <el-option
                        v-for="(item,index) in qyearList"
                        :key="item"
                        :label="item"
                        :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item  label="周" class="h-elformWrap-2" prop="username">
                  <el-select filterable v-model="q.week" clearable  placeholder="请选择"
                  >
                    <el-option
                        v-for="(item,index) in qweekList"
                        :key="item.week"
                        :label="item.weekStr"
                        :value="item.week">
                    </el-option>
                  </el-select>
                </el-form-item>


                </div>
                <el-collapse-transition>
                    <div class="h-thirdColumn w-newColumn">
                    </div>
                </el-collapse-transition>

              </el-form>
              <div class="l-screenBox">
                <div class="l-retrieval">
                  <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                  <el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>
                </div>
              </div>
            </div>
          </div>
            <!-- 结果展示 -->
            <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
                <!-- @selection-change="handleSelectionChange" -->
                <el-table
                    ref="multipleTable"
                    :data="tableData"
                    :border="true"
                    stripe
                    max-height="500"
                    show-summary
                    :summary-method="getSummaries"
                    :span-method="arraySpanMethod"
                    style="width: 100%" >
                        <el-table-column
                            label="序号"
                            type="index"
                            min-width="5%">
                        </el-table-column>
                  <el-table-column prop="userName" label="姓名" min-width="12%" ></el-table-column>
                  <el-table-column prop="quyuName"  label="区域" min-width="12%" ></el-table-column>
                  <el-table-column prop="titleName"  label="职位" min-width="12%" ></el-table-column>
                  <el-table-column prop="week" label="周" min-width="5%" ></el-table-column>
                  <el-table-column prop="customerCount" label="大客户" min-width="8%" ></el-table-column>
                  <el-table-column prop="projectCount" label="大项目" min-width="8%"  ></el-table-column>
                  <el-table-column prop="jiaohuCount" label="用户交互" min-width="8%"></el-table-column>
                  <el-table-column prop="changjingCount" label="新场景推进" min-width="8%" ></el-table-column>
                  <el-table-column prop="wangluoCount" label="网络运营" min-width="8%" ></el-table-column>
                  <el-table-column prop="kaifaCount" label="新网络开发" min-width="8%" ></el-table-column>
                  <el-table-column prop="planCount" label="计划数" min-width="8%" ></el-table-column>
                  <el-table-column prop="actualCount" label="实际数" min-width="8%" ></el-table-column>
                  <el-table-column prop="ying" label="应" min-width="8%"  ></el-table-column>
                  <el-table-column prop="cha" label="差"width="60">
                    <template slot-scope ="scope">
                        <span v-if="scope.row.planCount == 0 ">
                          未提报
                        </span>
                        <span v-if="scope.row.chas != '-5'">{{scope.row.chas}}</span>
                    </template>
                  </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL" style="margin-left: 23px">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportExcel">批量导出
            </el-button>
          </div>
        </div>

    </div>
</template>
<script>
import ss from "../../../api/SystemService";
import updownfile from '../../../utils/updownfile'
import util from "../../../utils/util";
import customerDetailsService from "../../../api/loud/credit/customerDetailsService";
import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
import cost from '../../../routes/cost';
import moment from "moment";
export default {
    data() {
        return {
            q:{
                userName:'',
                deptName:'',
                week:'',
                year:new Date().getFullYear(),
            },
            size:'',
            tableData: [
              {
                userName:null,
                quyuName:null,
                titleName:null,
                week:null,
                customerCount:null,
                projectCount:null,
                jiaohuCount:null,
                changjingCount:null,
                wangluoCount:null,
                kaifaCount:null,
                planCount:null,
                actualCount:null,
                ying:null,
                cha:null,
                chas:null,
              }
            ],
            times:[],
            qweekList :[],
            newDialog:false,
            writeNissin:false,
            editDialog:false,
            // 展开折叠筛选
            isScreen:false,
            yearList:[new Date().getFullYear(),new Date() .getFullYear()+1],
            weekList:[],
            nissin:{
              answerTime:'',
              defultFlag:'',
              dailyQuestion:'',
              customerName:'',
              visitDate:'',
              endDate:'',
              visitContent:"",
              dailyContent:'',
              isProject: 0,
              id:'',
              isConShow:false,
              isProjectBtn:false,
              chainGroupName:'',
              chainGroupCode:'',
              visitEffect:'',
              title:'',
              statusR:'',
              selectVisitEffect:['a','b'],
              gameTitles: [],
              subJieProgess: [], // 需求子节点数据
              childMsgId: '',
              //yucePrice: '', // 月预算在下单
              expConvDate: '',
              department:'',
              telephone:'',
              contactUserName:"",
              lianqunCode:'',
            },

            authTypeListEdit:[],
            wirteNissinList:[],
            disEdit:false,
            workList:[],
            deptList: [],
            AuthoCheck: '',
            authTypeList: [],
            userList: [0],
            weekPlanList:[],
            groupList: [],
            groupArr:[],
            titleDig:"",
            optionList:[],
            projectList:[],
            qyearList:[],
        }
    },
    methods: {
      //明细导出
      exportExcel() {
        updownfile.down("/api/swyl/v1/mubiao/userDailyTargetCollect/newDownloadExcel",this.q,"post",'data');
      },
        showFormList(value) {
            ss.MuBiao.getUser(value).then(res => {
                this.optionList = res.msg
            })
        },
        //项目类型
        getProject(){
            ss.MuBiao.getProject().then(res => {
                this.projectList = res.msg
            })
        },
        getDept(q){
          ss.MuBiao.getDeptList(q).then(rd => {
            this.deptList = rd;
          })
        },
        getKnowWeek() {
          var week1 = this.getWeekNum();
          this.qweekList.forEach(element => {
            if(week1 == element.week){
              this.q.week = element.week
            }
          });
        },
        getqWeeks(y,z){
          ss.MuBiao.getWeekList({year:y,stype:z}).then(rd => {
            this.qweekList = rd;
            this.getKnowWeek();
          })
        },
        groupListMe() {
            var data  = this.add.customerName
             ss.MuBiao.getUser(data).then(res => {
                this.groupList = []
                this.groupArr = []
                this.groupList = res.msg
                for(let item of this.groupList) {
                    this.groupArr.push({
                        value:item.userName,
                        id:item.userCode
                    })
                }
             })
        },

      //获取今年是第几周
      getWeekNum() {
        //获得当前日期是第几周的方法
        var year = new Date().getFullYear();
        var week = moment(new Date()).format("E");//获得今天是星期几
        var startweek = moment(new Date(year + "-01-01")).format("E");//获得今年的1月1号是星期几
        //今天到1月1号的时间戳之差
        var millisDiff =
            new Date(moment().format("yyyy-MM-DD")).getTime() -
            new Date(year + "-01-01").getTime();
        var days =
            (millisDiff -
                week * (24 * 60 * 60 * 1000) -
                (7 - startweek) * (24 * 60 * 60 * 1000)) /
            86400000;
        return days / 7 ;
        //这里加的2代表的是本周和今年1月1号所在的那一周
      },

      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0 || index === 1 || index === 2 ||index === 3 || index === 4) {
            sums[index] = '合计';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += '';
          } else {
            sums[index] = 'N/A';
          }
        });
        return sums;
      },
      arraySpanMethod() {
       this.$nextTick(() =>{
         if(this.$refs.multipleTable.$el){
           var current = this.$refs.multipleTable.$el
               .querySelector(".el-table__footer-wrapper")
               .querySelector(".el-table__footer");
           var cell = current.rows[0].cells;
           cell[0].style.display = "none";
           cell[1].style.display = "none";
           cell[2].style.display = "none";
           cell[3].style.display = "none";
           cell[4].classList.remove('is-left');
           cell[4].colSpan = "5";
         }
       })
      },

      query(){
      this.selectPageAll()
      },
      selectPageAll(){
        ss.MuBiao.getColletWeek(this.q).then(res => {
          this.tableData = res.msg

          for (var i =0 ;i<this.tableData.length;i++){
            var data = this.tableData[i];
            data.chas = data.cha;
          }
          //this.listProject = res.msg
        })
      },
        querySearchGroup(queryString, cb) {
            var groupArr = this.groupArr;
            cb(groupArr);
        },
        selectGroup(val) {
             this.add.customerName= val.value
        },
        groupListMe1() {
            var data  = this.edit.customerName
             ss.MuBiao.getUser(data).then(res => {
                this.groupList = []
                this.groupArr = []
                this.groupList = res.msg
                for(let item of this.groupList) {
                    this.groupArr.push({
                        value:item.userName,
                        id:item.userCode
                    })
                }
             })
        },
        querySearchGroup1(queryString, cb) {
            var groupArr = this.groupArr;
            cb(groupArr);
        },
        selectGroup1(val) {
             this.edit.customerName= val.value
        },

        changeHandler(value) {
            //console.log('改变之后的值是:' + value)
            let data =  this.authTypeList
            let item = this.add.userList
　　　　　　 // 使用find方法根据id查询对应对象
            let a =  data.find((ele)=>{
                return ele.id == item
            });
            var arr3 =a
            if(!arr3.id){
                    this.add.targetContent = '',
                    this.add.customerName= ''
                    this.add.clearType = 2
                    this.disEdit = true
                }else{
                    this.add.targetContent = arr3.targetContent,
                    this.add.customerName= arr3.customerName
                    this.add.clearType = 1
                    this.add.projectName = arr3.projectName
                    this.disEdit = false
                    this.add.id = this.add.userList
                }
        },
      handleFilter() {
        this.query();
      },
        groupChange() {
            if (this.add.userList.length > 1) {
                this.add.userList.shift();
            }
            var arr3 =[]
                this.add.userList.forEach((item) => {
					this.authTypeList.forEach((element) => {
						  if (item == element.id) {
							arr3.push(element)
						  }
					})
                })
                if(arr3.length == 0){
                    this.add.targetContent = '',
                    this.add.customerName= ''
                    //
                    this.add.clearType = 2
                    this.disEdit = false
                }else{
                    this.add.targetContent = arr3[0].targetContent,
                    this.add.customerName= arr3[0].customerName
                    this.add.clearType = 1
                    this.add.projectName = arr3[0].projectName
                    this.disEdit = true
                    this.add.id = this.add.userList[0]
                }
        },

        //获得周计划列表
        getWeekPlan(year,week){
            var year = this.add.year
            var week = parseInt(this.add.week)
            var data = {
                year:year,
                week:week
            }
            ss.MuBiao.getListPlan(data).then(res => {
                if(res.f == true ){
                    this.authTypeList = res.msg
                }else{
                    this.$message.error(res.msg);
                }
            })
        },

        getNowTime() {
            var now = new Date();
            var year = now.getFullYear(); //得到年份
            var month = now.getMonth(); //得到月份
            var date = now.getDate(); //得到日期
            month = month + 1;
            month = month.toString().padStart(2, "0");
            date = date - 1;
            date = date.toString().padStart(2, "0");
            var defaultDate = `${year}-${month}-${date}`;
            this.$set(this.q, "planCreateTime", defaultDate);
        },

        getWeeks(y){
            ss.MuBiao.getWeekList({year:y}).then(rd => {
                this.weekList = rd;
            })
        },
        getWeeksBySelectYear(){
            this.getWeeks(this.add.year);
            ss.createMonthGoal.getLianQunByUser(this.add).then(rd => {
                this.addlianqunList = rd;
            })
        },

        selectWeek(){
            this.getWeekPlan()
        },
        getqWeeksBySelectYear(){
            this.getqWeeks(this.q.year,1);
        },
        // 展开折叠
        collapseChange(){
            this.isScreen = !this.isScreen;
        },
        rest(){
            var week=this.q.week;
            var year=this.q.year;
            this.q= {
                userName:'',
                week: week,
                year:year
            }
        },
        exit(){
            this.closeDialog()
        },
      mounted() {
        this.selectPageAll();

      },
        closeDialog(){
            this.newDialog = false
            this.editDialog = false
            this.writeNissin = false
            this.xxx = '';//清空数据

            this.add.targetContent='',
            this.add.customerName='',
            this.add.clearType='2',
            this.add.projectName=''

            this.edit.targetContent='',
            this.edit.customerName='',
            this.edit.projectName=''

        },
    },
    watch:{
        'add.customerName': {
            deep: true,
            handler: function (newVal,oldVal){
            this.groupArr = [];//这是定义好的用于存放下拉提醒框中数据的数组
            var len = this.groupList.length;//groupList
            var arr = [];
            for (var i = 0; i < len; i++) {//根据输入框中的值进行模糊匹配
                if (this.groupList[i].name.indexOf(this.add.customerName) >= 0) {
                arr.push({
                    value:this.groupList[i].name,
                    id:this.groupList[i].id
                })
                }
            }
            this.groupArr = arr
            }
        },
    },
    created(){
        this.getWeeks(new Date().getFullYear());
        this.getqWeeks(new Date().getFullYear(),1);
        for(var i =2021;i<new Date() .getFullYear()+2;i++){
          this.qyearList.push(i);
        }
        this.handleFilter();
        this.getProject()
        this.getDept();
        this.getNowTime();
        this.q.week = this.getWeekNum()
    }
}
</script>
<style scoped>
    /deep/ .h-formbLine .el-form-item__label{
        width:80px;
    }
    /deep/  .h-formbLine .el-form-item__content{
        width:150px;
    }
    /deep/ .h-elformWrap-1 .el-form-item__content{
        width: 78%;
    }

    .projectCon p{
      justify-content: space-between;
      align-items:center;
      font-size: 14px;
      border-bottom:#1b78e6 1px dashed;
      padding: 5px 0;
      margin: 0 auto 10px auto;
      color: #1b78e6;
    }
</style>
